export function nl2br (str, isXhtml) {
  if (typeof str === 'undefined' || str === null) {
    return ''
  }
  // Adjust comment to avoid issue on locutus.io display
  const breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br ' + '/>' : '<br>'
  return (str + '')
    .replace(/(\r\n|\n\r|\r|\n)/g, breakTag + '$1')
}